import React from 'react';
import { makeStyles } from '@material-ui/core';
import {
  BaseButton,
  BaseDialog,
  BaseTypography,
  FormikField,
} from 'src/components/common';
import { useFormik } from 'formik';
import { IBaseForm } from 'src/utils/types/forms';
import { forgotPasswordValidationSchema } from './forgotPasswordValidationSchema';

export const useStyles = makeStyles(() => ({
  root: {},
  form__body: {
    display: 'grid',
    gridGap: '20px',
  },
}));

export type PForgotPasswordModal = IBaseForm<any> & {
  onClose: any;
  open: boolean;
};

export const ForgotPasswordModal: React.FC<PForgotPasswordModal> = (props) => {
  const { open, onClose, loading, onSubmit } = props;
  const classes = useStyles();
  const formik = useFormik({
    validationSchema: forgotPasswordValidationSchema,
    initialValues: {
      email: '',
    },
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: (values) => {
      onSubmit(values);
      formik.setErrors({});
    },
  });

  return (
    <BaseDialog
      open={open}
      paperStyles={{ maxWidth: '400px', width: '100%' }}
      onClose={onClose}
      title="Forgot password"
    >
      <form onSubmit={formik.handleSubmit}>
        <div className={classes.form__body}>
          <BaseTypography variant="caption">
            Enter your email address and we will send instructions on how to
            restore your account
          </BaseTypography>

          <FormikField label="Email" name="email" formik={formik} />

          <BaseButton type="submit" fullWidth loading={loading}>
            Send
          </BaseButton>
        </div>
      </form>
    </BaseDialog>
  );
};
